var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"portals"},[_c('SeviceApply'),_c('AddGoodsPop'),_c('BindSaasPop'),_c('ChooseMediaPop'),_c('WithdrawPop'),_c('WithdrawGuidePop'),_c('ChangeBindPhonePop'),_c('NicknamePop'),_c('AddAccountPop')],1)}
var staticRenderFns = []

export { render, staticRenderFns }